// Consent state — v2 supports per-category flags while remaining backward
// compatible with the v1 "all" / "necessary" string values written by the
// original single-choice banner.
//
// Keys stored under localStorage['gospeleon.cookieConsent']:
//   v1: "all"        → analytics ON, advertising ON
//   v1: "necessary"  → both OFF
//   v2: JSON string  → { v: 2, analytics: bool, advertising: bool }
//
// Downstream helpers (`hasAnalyticsConsent`, `hasAdvertisingConsent`) parse
// both shapes. Write path prefers v2 whenever the user opens Customize.
export const CONSENT_KEY = 'gospeleon.cookieConsent';
export const CONSENT_EVENT = 'cookie-consent-changed';

function readRaw() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

export function getConsent() {
  const raw = readRaw();
  if (!raw) return { analytics: false, advertising: false, decided: false };
  if (raw === 'all') return { analytics: true, advertising: true, decided: true };
  if (raw === 'necessary') return { analytics: false, advertising: false, decided: true };
  try {
    const parsed = JSON.parse(raw);
    return {
      analytics: !!parsed.analytics,
      advertising: !!parsed.advertising,
      decided: true,
    };
  } catch {
    return { analytics: false, advertising: false, decided: false };
  }
}

export function saveConsent(next) {
  const payload = JSON.stringify({ v: 2, analytics: !!next.analytics, advertising: !!next.advertising });
  try { localStorage.setItem(CONSENT_KEY, payload); } catch { /* storage blocked */ }
  try { window.dispatchEvent(new Event(CONSENT_EVENT)); } catch { /* jsdom */ }
}

export function hasAdvertisingConsent() {
  return getConsent().advertising;
}
